import { Role } from '@/model/role';
import type { RouteRecordRaw } from 'vue-router';

const Home = () => import('@/components/public/Home.vue');
const Book = () => import('@/components/public/Book.vue');

const publicRoutes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pro',
    name: 'Home',
    component: Home,
    meta: {
      public: true,
      role: Role.GUEST,
    },
  },
  {
    path: '/',
    name: 'Book',
    component: Book,
    meta: {
      public: true,
      role: Role.GUEST,
    },
  },
];
export default publicRoutes;
